import { useEffect, useState } from "react";
import LightBulb from "../../assets/icons/Lightbulb.svg";
import { stepConfig } from "./config";
import styles from "./styles.module.scss";

const CooLearningMaterials = ({ activeStep }: { activeStep: number }) => {
  const [visible, setVisible] = useState(true);

  const config = stepConfig[activeStep];

  useEffect(() => {
    setVisible(true);
  }, [activeStep]);

  if (!config) return null;

  return (
    <div className={styles.wrapper}>
      <button className={styles.toggle} onClick={() => setVisible(!visible)}>
        {!visible && (
          <>
            <img src={LightBulb} alt="LightBulb" height={16} width={16} />
            <span>SHOW LEARNING MATERIALS</span>
          </>
        )}
      </button>
      {visible && (
        <div className={styles.card}>
          <div className={styles.cardWrapper}>
            <div className={styles.left}>
              <button className={styles.ht} onClick={() => setVisible(false)}>
                HIDE LEARNING MATERIALS
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CooLearningMaterials;
